import { render, staticRenderFns } from "./Agendar.vue?vue&type=template&id=12fc7d47&scoped=true&"
import script from "./Agendar.vue?vue&type=script&lang=ts&"
export * from "./Agendar.vue?vue&type=script&lang=ts&"
import style0 from "./Agendar.vue?vue&type=style&index=0&id=12fc7d47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc7d47",
  null
  
)

export default component.exports